import { getActivePinia, type Pinia, type Store } from 'pinia'
import { LIST_STORE_EXCLUDE_RESET } from '~/constants'

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>
}

export function useResetStore() {
  const pinia = getActivePinia() as ExtendedPinia

  if (!pinia) {
    throw new Error('There is no active Pinia instance')
  }

  const resetStores: Record<string, () => void> = {}

  pinia._s.forEach((store, name) => {
    resetStores[name] = () => {
      store.$reset()
    }
  })

  resetStores.all = () => {
    sessionStorage.removeItem('isLogged')
    setTimeout(() => {
      useCookie('token').value = null
    }, 1000)
    pinia._s.forEach(store => {
      if (!LIST_STORE_EXCLUDE_RESET.includes(store.$id)) {
        store.$reset()
      }
    })
  }

  return resetStores
}
